import * as React from "react";
import {Box, styled, Typography} from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';

type props = {
  activeStep: number,
  amountOfSteps: number,
  showOnFirst?: boolean
}

const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 9,
  borderRadius: 20,
  flexGrow: 1,
  marginRight: "16px",
  backgroundColor: theme.palette.stepper.main,
}));

export default function SignSteps({activeStep, amountOfSteps, showOnFirst = false}: props) {
  return (
    <>
      {(showOnFirst || activeStep > 0) && <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center" mb={4} sx={{width: "100%"}}>
        <StyledLinearProgress variant="determinate" value={(activeStep / (amountOfSteps - 1)) * 100}/>
        <Typography>{activeStep}/{amountOfSteps - 1}</Typography>
      </Box>}
    </>
  )
}